import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';

const FaqImage = styled.img`
  ${tw`block mx-auto my-abs3 px-def`}
  max-width: ${(props) => `${props.imgSizePercent}%`};
`;

class ArticleImage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      imageUrl: '',
    };

    import(`../../../images/faq/${this.props.content}`).then((img) => {
      this.setState(() => ({
        imageUrl: img.default,
      }));
    });
  }

  render() {
    const [altImage] = this.props.content.split('.');
    return (
      <FaqImage
        alt={this.props.imgAlt || altImage}
        imgSizePercent={this.props.imgSizePercent}
        src={this.state.imageUrl}
      />
    );
  }
}

ArticleImage.propTypes = {
  content: PropTypes.string,
  imgAlt: PropTypes.string,
  imgSizePercent: PropTypes.number,
};

ArticleImage.defaultProps = {
  imgSizePercent: 100,
  imgAlt: null,
};

export default ArticleImage;
